import React from 'react';

const ProcessingButton = ({ 
  onClick, 
  disabled, 
  isLoading, 
  loadingText, 
  children, 
  icon: Icon,
  variant = "primary",
  className = ""
}) => {
  const baseClasses = "w-full py-2 px-4 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2 justify-center";
  
  const variantClasses = {
    primary: "bg-blue-600 text-white hover:bg-blue-700",
    success: "bg-green-600 text-white hover:bg-green-700",
    warning: "bg-orange-600 text-white hover:bg-orange-700",
    danger: "bg-red-600 text-white hover:bg-red-700",
    purple: "bg-purple-600 text-white hover:bg-purple-700",
    indigo: "bg-indigo-600 text-white hover:bg-indigo-700"
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
    >
      {isLoading ? (
        <>
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
          {loadingText}
        </>
      ) : (
        <>
          {Icon && <Icon className="w-4 h-4" />}
          {children}
        </>
      )}
    </button>
  );
};

export default ProcessingButton;
